import Vue from 'vue';
import Component from 'vue-class-component';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';

@Component({
  name: 'presentation-mode-view',
  components: {
  },
})
export default class PresentationModeView extends Vue {

  /* Data */
  public validating: boolean = true;
  public loading: boolean = true;

  /* Methods */
  public async validate(publicToken: string,  classId: string, id : string, meetingId: string) {
    try {
      let response = await this.$Auth.Services.validatePublicToken(publicToken);
      if(response) {
        LocalStorageService.setItem(AUTH_STORAGE_KEYS.ED_JWT, response);
        this.validating = true;
        let url = PRIVATE_ROUTES.JOIN_MEETING.PATH.replace(
          ':classId', classId
        ).replace( 
          ':id', id,
        ).replace(
          ':meetingId', meetingId
        );
        window.location.href = process.env.VUE_APP_HOSTNAME_WEB + process.env.VUE_APP_CONTEXT + '/p/' + url + '?webview=true';
      }
    } catch {
      this.validating = false;
    }
    this.loading = false;
  }

  created() {
    this.$App.Store.setHeaderVisible(false);
    this.validate(this.$route.params.publicToken, this.$route.params.classId, this.$route.params.id, this.$route.params.meetingId);
  }
  
}